import { UserProject } from '../types/project.types';
import { getEnvironment } from './';

export const CPA_ADMIN_URL =
	'https://cpa.autodesk.com/project-admin/members/projects/';

export const PRODUCT_BASE_URLS = {
	info360Insight: 'https://app.info360.com/',
	info360Asset: 'https://asset.info360.com/',
	info360Model: 'https://model.info360.autodesk.com/',
	info360Plant: 'https://app.info360.com/',
	projectAdministration: CPA_ADMIN_URL,
};

const productUrlSuffixMap = {
	LOCAL: 'dev',
	DEV: 'dev',
	QA: 'qa',
	STAGE: 'stg',
	PROD: null,
};

type Region = 'US' | 'EMEA' | 'APAC';
type RegionSuffix = null | 'eu' | 'ap';

const getProductUrl = (product: string, region: Region): string => {
	let url = PRODUCT_BASE_URLS[product] ?? PRODUCT_BASE_URLS.info360Insight;
	const environment =
		product !== 'info360Model' && getEnvironment() === 'STAGE'
			? 'QA'
			: getEnvironment();

	const envSuffix = productUrlSuffixMap[environment] ?? null;
	if (envSuffix && region === 'US') {
		//environment is US specific
		url = url.replace('info360', `info360-${envSuffix}`);
	}

	let regionSuffix: RegionSuffix = null;
	if (region !== 'US') {
		regionSuffix = region === 'EMEA' ? 'eu' : 'ap';
	}
	if (regionSuffix && environment === 'PROD') {
		//region suffix is only added for PROD environment
		url = url.replace('info360', `info360-${regionSuffix}`);
	}
	return `${url}projects/`;
};

const getCPAAdminUrl = (hubRegion: Region) => {
	const env = getEnvironment();

	let cpaUrl = PRODUCT_BASE_URLS.projectAdministration;
	if (env !== 'PROD') cpaUrl = cpaUrl.replace('cpa', 'cpa-staging');

	if (hubRegion === 'EMEA') {
		cpaUrl = cpaUrl.replace('autodesk', 'autodesk.eu');
	}
	if (hubRegion === 'APAC') {
		cpaUrl = cpaUrl.replace('autodesk', 'aus.autodesk');
	}

	return cpaUrl;
};

export const generateProductUrls = (projects: UserProject[]) => {
	return projects.map(project => {
		const { sourceId, hubRegion, userProducts } = project;

		return {
			...project,
			userProducts: userProducts.map(product => {
				const newUrl =
					product.name === 'projectAdministration'
						? getCPAAdminUrl(hubRegion as Region)
						: getProductUrl(product.name, hubRegion as Region);
				return { ...product, url: `${newUrl}${sourceId}` };
			}),
		};
	});
};
